var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        width: "420px",
        "show-close": false,
        "close-on-click-modal": false,
        "close-on-press-escape": !_vm.submitting,
        "append-to-body": "",
        "custom-class": "integral-audit-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        closed: _vm.resetForm,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "auditFormRef",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-width": "100px",
            size: "small",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "审核结果：", prop: "auditStatus" } },
            [
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.handleAuditStatusChange },
                  model: {
                    value: _vm.form.auditStatus,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "auditStatus", $$v)
                    },
                    expression: "form.auditStatus",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("通过")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 2 } }, [_vm._v("驳回")]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.form.auditStatus === 2
            ? _c(
                "el-form-item",
                { attrs: { label: "驳回原因：", prop: "rejectReason" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      maxlength: "255",
                      "show-word-limit": "",
                      resize: "none",
                      placeholder: "请输入驳回原因",
                    },
                    model: {
                      value: _vm.form.rejectReason,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "rejectReason", $$v)
                      },
                      expression: "form.rejectReason",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", plain: "", disabled: _vm.submitting },
              on: { click: _vm.close },
            },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.submitting },
              on: { click: _vm.submit },
            },
            [_vm._v("确认")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }